export class Sex {
	public static from(male: boolean, female: boolean): string {
		let sex = null;
		if (male) {
			sex = 'male';
		} else if (female) {
			sex = 'female';
		}
		return sex;
	}

	public static isMale(sex: string): boolean {
		return sex === 'male';
	}

	public static isFemale(sex: string): boolean {
		return sex === 'female';
	}
}

export class Generation {
	public static from(firstGen: boolean, secondGen: boolean): number {
		let generation = null;
		if (firstGen) {
			generation = 1;
		} else if (secondGen) {
			generation = 2;
		}
		return generation;
	}

	public static firstGen(gen: string): boolean {
		return gen === '1';
	}

	public static secondGen(gen: string): boolean {
		return gen === '2';
	}

}